export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.max-shipping.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.max-shipping.aria-label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.max-shipping.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
